import { useContext } from 'react'
import Script from 'next/script'
import { SiteBuilderContext } from '@/siteBuilder/renderer/context/SiteBuilderContext'

const BUNDLE_URL = 'https://ops.cloudstackservices.com/js/FlexDonationForm/donationManager-bundle.js'
const ORG_ID = '00DDn00000136RJMAY'
const FORM_IDS = {
  en: 'a1KDn000002lgL0MAI',
  fr: 'a1KDn00000351EdMAI',
}

const LEGACY_IFRAME_URL = 'https://telusfriendlyfuturefoundation.my.salesforce-sites.com/Fundraising'

const BXDonationCheckoutForm = ({ donation, useEmbeddedForm = false, bxDonationFormHeight = 260 }) => {
  const { locale } = useContext(SiteBuilderContext)

  const lang = locale?.language === 'fr' ? 'fr' : 'en'

  if (!donation) return null

  // TODO: remove the legacy iframe (and bxDonationFormHeight) once the embedded form is rolled out
  if (!useEmbeddedForm)
    return (
      <iframe
        style={{ borderWidth: 0 }}
        title="bx-donation-form"
        src={`${LEGACY_IFRAME_URL}?id=${FORM_IDS[lang]}`}
        width="100%"
        height={`${bxDonationFormHeight}px`}
      ></iframe>
    )

  return (
    <>
      {/* The bundle's MutationObserver mounts the form (in a Shadow DOM) into any element with this class */}
      <div
        key={lang}
        className="donationManager-embed-mount"
        data-org-id={ORG_ID}
        data-form-id={FORM_IDS[lang]}
        data-lang={lang}
        data-testid="bx-donation-form"
      />
      <Script id="bx-donation-form-script" strategy="afterInteractive" src={BUNDLE_URL} />
    </>
  )
}

export default BXDonationCheckoutForm
